/**
 * QL-593 — how many goals one flow instance may hold.
 *
 * A multi-goal flow carries its own cap (`flow.maxGoals`, designer-set within
 * MIN..MAX); a single-goal flow is always capped at one, whatever the stored
 * value says. `goalLimitForFlow` is that rule for callers that see both kinds
 * of flow (the goal service, the Goal List component). The follow-up
 * pre-flight and the goal tab bar only run for multi-goal flows, so they
 * compare against `maxGoals` directly.
 */

export const FLOW_MAX_GOALS_MIN = 1;
export const FLOW_MAX_GOALS_MAX = 30;
export const FLOW_MAX_GOALS_DEFAULT = 3;

/** Above this many goals the goal tabs collapse into one dropdown. */
export const GOAL_TABS_MAX_VISIBLE = 5;

export function isValidFlowMaxGoals(value: unknown): value is number {
  return (
    typeof value === "number" &&
    Number.isInteger(value) &&
    value >= FLOW_MAX_GOALS_MIN &&
    value <= FLOW_MAX_GOALS_MAX
  );
}

/** The effective cap for an instance of this flow. */
export function goalLimitForFlow(flow: { multiGoal: boolean; maxGoals: number }): number {
  return flow.multiGoal ? flow.maxGoals : 1;
}
